const getApiUrl = () => {
  // Check if we're running on dev.stillloved.co.uk
  if (window.location.hostname === 'dev.stillloved.co.uk') {
    return 'https://api.dev.stillloved.co.uk';
  }
  
  // Check if we're running on production
  if (window.location.hostname === 'stillloved.co.uk' || window.location.hostname === 'www.stillloved.co.uk') {
    return 'https://api.stillloved.co.uk';
  }

  if (window.location.hostname.includes('d1r1e84u7682n7.cloudfront.net')) {
    return 'https://api.stillloved.co.uk';
  }
  
  // Default to localhost for local development
  return 'http://localhost:5001';
};

export const API_URL = getApiUrl();

// Debug log to verify the API URL
//console.log('API URL:', API_URL, 'Hostname:', window.location.hostname); 